import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';
import { GlobalImport } from '../../utils/GlobalImport';
import { block_translation } from '../../lang/BlockTranslation';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class StaticBodyAttribute extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.STATIC_BODY, t.to('動かない', 'static_body'));
    this.setNameForCode('static-body');
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setPhysicsSystemColor(block);
    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const shape = 'box';

    const sceneStr = `(scene ? scene:document.querySelector("a-scene")).setAttribute("physics","driver: ammo; debug: false; debugDrawMode: 1;");`;
    const inner_attr = CodeSetting.buildAttribute(
      [
        ['autofit-ammo', `type:kinematic;shape:${shape}`],
        ['class', 'collidable'],
      ],
      attribute
    );
    return [inner_attr + sceneStr];
  }
}
